import moment from 'moment'

const helper = {
  getTrueFormatData(data) {
    let date = new Date(data * 1000)
    // date.setMilliseconds(+data);
    let year = date.getFullYear()
    let month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
    let day = date.getDay() > 9 ? date.getDay() : '0' + date.getDay()
    let hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
    let minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
    let seconds = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds()
    return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
  },
  getTrueDataYearsMonthDayFormat(data) {
    let date = new Date(data * 1000)
    let year = date.getFullYear()
    let month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
    let day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
    return year + '-' + month + '-' + day
  },
  getDataInUnix(date) {
    let dataArray = date.split('-')
    let Unix = new Date(+dataArray[0], (+dataArray[1]) - 1, +dataArray[2])
    return Unix.valueOf() / 1000
  },
  fixDate(date, fmt, utcOffset) {
    if(utcOffset ==  undefined)   utcOffset = 3;

    let result = moment(date, "YYYY-MM-DD HH:mm:ss").add(utcOffset, 'h');
    
    if(fmt ==  undefined)  fmt = 'YYYY/MM/DD HH:mm';
    if(fmt) {
      return result.format(fmt);
    }

  },
  expectedWithdrawTime (relative_to, fmt){
  
    var t_expected = moment();
    if(relative_to!=undefined)
      t_expected = moment(relative_to);
    
      t_expected = t_expected.utc().utcOffset(3).add(6, 'h'); 
      if(t_expected.hours()>=1 && t_expected.hours()<10) 
      t_expected.hours(10);

    if(fmt==undefined) fmt = 'YYYY/MM/DD HH:00';
    if(fmt) {
      return t_expected.format(fmt);
    }
    return t_expected;
  },
  getDataLastMonthInUnix() {
    let dateNow = new Date()
    let startDate = dateNow.valueOf() / 1000
    let firstDayThisMonth = new Date(dateNow.getFullYear(), dateNow.getMonth(), 1)
    let endDate = firstDayThisMonth.valueOf() / 1000
    return {
      startDate: startDate,
      endDate: endDate
    }
  },
  getDataLastMonth() {
    let dateTo, dateFrom
    let date = new Date()
    dateTo = date.valueOf() / 1000
    dateTo = this.getTrueDataYearsMonthDayFormat(dateTo)
    dateFrom = date.setMonth(date.getMonth() - 1) / 1000
    dateFrom = this.getTrueDataYearsMonthDayFormat(dateFrom)
    return {
      startDate: dateFrom,
      endDate: dateTo
    }
  },
}
export default helper



// WEBPACK FOOTER //
// ./src/components/helper/helper.js